

  setInterval(updateMeasurementsBlock, 1000);
 

async function updateMeasurements() {

  

  let id = await resolveUserId();
  id = id.id;
  
      var settings = {
        url:
          "https://orders.editsuits.com/api/customers/" +
          id +
          "/editable_categories",
        method: "GET",
        timeout: 0,
        headers: {
          token: "bd0ceb613c5a41a0be91623183ddfb5c",
          Authorization: "Bearer bd0ceb613c5a41a0be91623183ddfb5c",
          "Content-Type": "text/plain",
        },
        data: "",
      };

      $.ajax(settings).done(function (response) {
        let editableCategories = [];
        var sizesGrid = $(".sizes_grid");
        for (const [key, value] of Object.entries(
          response.editable_categories
        )) {
          if (value === "YES" || value === "NO") {
            editableCategories.push(key);
          }
        }

        if (editableCategories.length > 0) {
          localStorage.setItem(
            "customer_measurements",
            JSON.stringify(editableCategories)
          );
        } else {
          localStorage.setItem(
            "customer_measurements",
            'none'
          );
        }
      });

  
}

/* setting up measurement blocks */

function updateMeasurementsBlock(page) {

let customerMeasurements = localStorage.getItem("customer_measurements");
// cart page
let theseItems = "These items";

let cartCategories = checkCartMeasurements(customerMeasurements);

if ($('.cart-items .cart-item').length === 1) theseItems = 'This item';

// Parse translations if needed (Liquid sometimes outputs as string instead of object)
let greyAuthTranslations = window.translations?.GreyAuthMeasurementBar;
if (typeof greyAuthTranslations === 'string') {
  try {
    // Decode HTML entities and parse
    const textarea = document.createElement('textarea');
    textarea.innerHTML = greyAuthTranslations;
    const decoded = textarea.value;
    // Convert Ruby hash format to JSON
    greyAuthTranslations = eval('(' + decoded.replace(/=>/g, ':') + ')');
  } catch (e) {
    console.error('Failed to parse cart translations:', e);
    greyAuthTranslations = null;
  }
}

// Get translations for cart
const cartNotLoggedIn = greyAuthTranslations?.not_logged_in || {
  heading: "This item will be made to your personal size.",
  message: `Visit a showroom to get measured or {login_link} to access existing measurements.`,
  login_link_text: "log in"
};

const cartLoggedInWithMeasurements = greyAuthTranslations?.logged_in_with_measurements || {
  heading: "This item will be made to your personal size.",
  message: "Review your size now"
};

const cartLoggedInNoMeasurements = greyAuthTranslations?.logged_in_no_measurements || {
  heading: "This item will be made to your personal size.",
  message: "Visit a showroom to get measured."
};

if (cartCategories === "auth") {
  const loginLink = `<a href="https://www.editsuits.com/account/login?return_to=${window.location.href}"  rel="nofollow">${cartNotLoggedIn.login_link_text}</a>`;
  const message = cartNotLoggedIn.message.replace('{login_link}', loginLink);
  
  $("#measurements_block_cart").html(
    `<p><b>${cartNotLoggedIn.heading.replace('This item', theseItems)}</b><br/> <a href="#showroom" title="#showroom"><svg data-v-b44088fc="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1"><path data-v-b44088fc="" d="M18.4707 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M14.3242 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M10.17773 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M6.72105 10.29785C9.39313 10.29785 11.5593 9.40242 11.5593 8.29785C11.5593 7.19328 9.39313 6.497852 6.72105 6.497852C4.04896 6.497852 1.882812 7.19328 1.882812 8.29785C1.882812 9.40242 4.04896 10.29785 6.72105 10.29785Z" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M1.882812 15.29785C1.882812 16.4029 4.04896 17.2979 6.72105 17.2979H22.6181V10.29785H6.72105C4.04896 10.29785 1.882812 9.40285 1.882812 8.29785V15.29785Z" stroke-linecap="round" stroke-linejoin="round"></path></svg>Visit a showroom</a> to get measured or ${loginLink} to access existing measurements.</p>`
  );
} else {
  if (cartCategories && customerMeasurements !== 'none') {
    $("#measurements_block_cart").html(
      ` <p><b>${cartLoggedInWithMeasurements.heading.replace('This item', theseItems)}</b><br/> <a href="/account#My-sizes" title="#showroom"><svg data-v-b44088fc="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1"><path data-v-b44088fc="" d="M18.4707 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M14.3242 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M10.17773 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M6.72105 10.29785C9.39313 10.29785 11.5593 9.40242 11.5593 8.29785C11.5593 7.19328 9.39313 6.497852 6.72105 6.497852C4.04896 6.497852 1.882812 7.19328 1.882812 8.29785C1.882812 9.40242 4.04896 10.29785 6.72105 10.29785Z" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M1.882812 15.29785C1.882812 16.4029 4.04896 17.2979 6.72105 17.2979H22.6181V10.29785H6.72105C4.04896 10.29785 1.882812 9.40285 1.882812 8.29785V15.29785Z" stroke-linecap="round" stroke-linejoin="round"></path></svg>${cartLoggedInWithMeasurements.message}</a>.</p>`
    );
  } else {
    $("#measurements_block_cart").html(
      `<p><b>${cartLoggedInNoMeasurements.heading.replace('This item', theseItems)}</b><br/> You can edit your measurements <a href="/account" title="#showroom">here</a>.<br/><b>Please note that we do not have all the required measurements for your order.</b><br/><a href="#showroom" title="#showroom"><svg data-v-b44088fc="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1"><path data-v-b44088fc="" d="M18.4707 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M14.3242 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M10.17773 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M6.72105 10.29785C9.39313 10.29785 11.5593 9.40242 11.5593 8.29785C11.5593 7.19328 9.39313 6.497852 6.72105 6.497852C4.04896 6.497852 1.882812 7.19328 1.882812 8.29785C1.882812 9.40242 4.04896 10.29785 6.72105 10.29785Z" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M1.882812 15.29785C1.882812 16.4029 4.04896 17.2979 6.72105 17.2979H22.6181V10.29785H6.72105C4.04896 10.29785 1.882812 9.40285 1.882812 8.29785V15.29785Z" stroke-linecap="round" stroke-linejoin="round"></path></svg>${cartLoggedInNoMeasurements.message}</a></p>`
    );
  }
}

let customerId = $('#customerShopifyId').val();

// product page
if (customerMeasurements === null && !customerId) {
  
  // Parse if it's a string (Liquid sometimes outputs as string instead of object)
  let greyAuthTranslations = window.translations?.GreyAuthMeasurementBar;
  if (typeof greyAuthTranslations === 'string') {
    try {
      // Decode HTML entities and parse
      const textarea = document.createElement('textarea');
      textarea.innerHTML = greyAuthTranslations;
      const decoded = textarea.value;
      // This is still Ruby hash format, so we need to convert it to JSON
      greyAuthTranslations = eval('(' + decoded.replace(/=>/g, ':') + ')');
    } catch (e) {
      console.error('Failed to parse translations:', e);
      greyAuthTranslations = null;
    }
  }
  
  const translations = greyAuthTranslations?.not_logged_in || {
    heading: "This item will be made to your personal size.",
    message: `Visit a showroom to get measured or {login_link} to access existing measurements.`,
    button_text: "Book your appointment",
    login_link_text: "log in"
  };
  
  const loginLink = `<a href="https://www.editsuits.com/account/login?return_to=${encodeURIComponent(window.location.href)}" rel="nofollow">${translations.login_link_text}</a>`;
  const message = translations.message.replace('{login_link}', loginLink);
  
  $("#measurements_block_product").html(
    `<p><b>${translations.heading}</b><br/>${message}</p> <a href="#showroom" class="bookCTA button button--full-width button--primary">${translations.button_text}</a>`
  ); 
  $("button.loAtc").addClass('notLoggedInAtc');
} else {

  if (!customerMeasurements) {
    customerMeasurements = 'none';
    updateMeasurements();
  }
  
  
  if (customerMeasurements !== 'none') {
  customerMeasurements = JSON.parse(customerMeasurements);
  }
  if (
    customerMeasurements.includes($("#productCategory").val()) ||
    ($("#productCategory").val() === "Suit" &&
      customerMeasurements.includes("Pants") &&
      customerMeasurements.includes("Jacket")) ||
    ($("#productCategory").val() === "Trouser" &&
      customerMeasurements.includes("Pants")) ||
    ($("#productCategory").val() === "Chino" &&
      customerMeasurements.includes("Chinos")) && customerMeasurements !== 'none'
  ) {
     const translations = window.translations?.GreyAuthMeasurementBar?.logged_in_with_measurements || {
       heading: "This item will be made to your personal size.",
       message: "Review your size now",
       icon_label: "Review measurements"
     };
     
     $("button.loAtc").removeClass('notLoggedInAtc');
    $("#measurements_block_product").html(
      ` <p><b>${translations.heading} </b> <br/><a href="/account#My-sizes" title="#showroom"><svg data-v-b44088fc="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1"><path data-v-b44088fc="" d="M18.4707 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M14.3242 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M10.17773 17.2979V14.29785" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M6.72105 10.29785C9.39313 10.29785 11.5593 9.40242 11.5593 8.29785C11.5593 7.19328 9.39313 6.497852 6.72105 6.497852C4.04896 6.497852 1.882812 7.19328 1.882812 8.29785C1.882812 9.40242 4.04896 10.29785 6.72105 10.29785Z" stroke-linecap="round" stroke-linejoin="round"></path><path data-v-b44088fc="" d="M1.882812 15.29785C1.882812 16.4029 4.04896 17.2979 6.72105 17.2979H22.6181V10.29785H6.72105C4.04896 10.29785 1.882812 9.40285 1.882812 8.29785V15.29785Z" stroke-linecap="round" stroke-linejoin="round"></path></svg>${translations.message}</a>.</p>`
    );
  } else {
     const translations = window.translations?.GreyAuthMeasurementBar?.logged_in_no_measurements || {
       heading: "This item will be made to your personal size.",
       message: "Visit a showroom to get measured.",
       button_text: "Book your appointment"
     };
     
     $("button.loAtc").addClass('notLoggedInAtc');
    $("#measurements_block_product").html(
      `<p><b>${translations.heading}</b><br/> ${translations.message} </p> <a href="#showroom" class="bookCTA button button--full-width button--primary">${translations.button_text}</a>`
    );
  }
}

    
  
}

